import { routeAccessManifest } from '@shared/constants/routeAccessManifest'
import { type ParamMap } from '@next-types/routes'
import {
  SHOP_DEALS_APP_ROUTER,
  type ServerExperiment,
} from '@shared/constants/server_side_experiments'

// every route carries its own experiment so it can be ramped and killed alone.
// adding a page here is the only change the proxy and the link related primitives need.
// urlPattern is the public /shop URL, not the internal /shop-next one.
export const MIGRATED_URL_PATTERNS: {
  urlPattern: keyof ParamMap
  experiment: ServerExperiment
}[] = [
  {
    urlPattern: '/shop/[store_slug]/deals',
    experiment: SHOP_DEALS_APP_ROUTER,
  },
]

// the regex comes from the manifest so it can never drift from the real route.
// a drifted manifest must not take the proxy or hydration down, so an unresolved
// pattern drops out here and appRouterMigration.spec fails on the length check.
export const MIGRATED_ROUTES = MIGRATED_URL_PATTERNS.flatMap(({ urlPattern, experiment }) => {
  const entry = routeAccessManifest.find((e) => e.urlPattern === urlPattern)
  return entry ? [{ ...entry, experiment }] : []
})

export type MigratedRoute = (typeof MIGRATED_ROUTES)[number]

// callers resolve an href to a pathname before getting here, so query and hash are gone.
// only match when the migrated route is the first manifest match, which is the route next
// actually serves since the manifest uses next's own sort. /shop/kits/deals matches
// /shop/[store_slug]/deals too, but next serves /shop/kits/[id] there so we leave it alone.
export const matchMigratedRoute = (pathname: string) => {
  const servedBy = routeAccessManifest.find(({ regex }) => regex.test(pathname))
  if (!servedBy) return undefined
  return MIGRATED_ROUTES.find(({ urlPattern }) => urlPattern === servedBy.urlPattern)
}
